import { render, staticRenderFns } from "./SmsTemplateMmLista.vue?vue&type=template&id=be94ba2a"
import script from "./SmsTemplateMmLista.vue?vue&type=script&lang=js"
export * from "./SmsTemplateMmLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports